

import React from 'react';
import ZUtil from "./zutil";
import AMC from "./AMC";
import PleaseStandBy from "./PleaseStandBy";

export default class AMCUserPurchaseFailedPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let parms = ZUtil.getQueryParms();
		AMC.getPricingPlans((err, plans) => {
			if (!err && (parms.plan_id || parms.product_id)) {
				let plan = plans.plans[parms.plan_id || parms.product_id];
				if (plan) {
					this.setState({ plan: plan });
				}
			}
		});
	}
	render() {
		let { plan } = this.state;
		if (!plan) {
			return <PleaseStandBy />;
		}
		return	(
			<div className="AMCUserPurchaseFailedPage">
				<div className="CENTEREDPART">
					<h1>Thank you for your interest in the<br/>{plan.nickname}.</h1>
					<p style={{marginTop: "3em"}}>Please <strong><a href="mailto:contact@automatic.ai">contact us</a></strong><br/>if you have any questions or concerns.</p>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCUserPurchaseFailedPage.js